<template>
    <div>Adults <font-awesome-icon :icon="['fas', 'circle-info']" size="xs" color="#0D47A1" :style="{ 'vertical-align': 'top', 'top': '2px' }" /></div>
</template>

<script>
    import AddPropertyModal from './reservation-details-add-properties-modal.vue';

    export default {};
</script>
